import React from 'react'
import ReactDOM from 'react-dom'
import CustomMuiTimePicker from '../ReactComponents/Components/CustomMuiTimepicker'

angular.module('common.directives').directive('customTimepicker', function () {
  return {
    scope: {
      selectedTime: '=',
      timeChange: '='
    },
    template: '<div class="custom-element"></div>',
    link: ($scope, $element) => {
      const linkStateUpdater = stateUpdater => {
        $scope.$watch('selectedTime', () => {
          stateUpdater(Math.random())
        })
      }
      const handleTimeChange = date => {
        console.log(date)
        $scope.selectedTime = date
        $scope.timeChange && $scope.timeChange(date)
        $scope.$apply()
      }
      ReactDOM.render(
        <CustomMuiTimePicker
          getSelectedTime={() => $scope.selectedTime || new Date()}
          timeChange={date => handleTimeChange(date)}
          linkStateUpdater={linkStateUpdater}
        />,
        $element[0]
      )
      $scope.$on('$destroy', () => {
        ReactDOM.unmountComponentAtNode($element[0])
      })
    }
  }
})
